var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-hover',{attrs:{"open-delay":0,"close-delay":25},scopedSlots:_vm._u([{key:"default",fn:function({ hover }){return [_c('li',{staticClass:"base-list-item f14 py-4 px-7",class:(hover ? 'primary white--text pointer' : 'primary--text white') +
      ' ' +
      (_vm.uppercase ? 'uppercase' : ''),on:{"click":function($event){_vm.item.click ? _vm.item.click() : undefined}}},[_vm._v(" "+_vm._s(_vm.item.title)+" ")])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }